import React, { useEffect, useState } from "react";
import { Table } from "antd";
import SystemApi from "../../api/sys";
import RenderTxt from "../../components/renderTxt";

export default ({ deviceId }) => {
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [rating, setRating] = useState(0);
  const columns = [
    {
      title: "故障原因",
      dataIndex: "alarmName",
      align: "center",
      key: "alarmName",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
    {
      title: "次数",
      dataIndex: "times",
      align: "center",
      key: "times",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
    {
      title: "权重",
      dataIndex: "weight",
      align: "center",
      key: "weight",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
    {
      title: "占比",
      dataIndex: "proportion",
      align: "center",
      key: "proportion",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
  ];

  useEffect(() => {
    if (deviceId) {
      getList();
    }
  }, [deviceId]);

  const getList = () => {
    setLoading(true);
    SystemApi.listIntegrityRate({ id: deviceId }).then((res) => {
      setLoading(false);
      if (res.status !== "0") return;
      const { integrityRateList, healthScore } = res.data;
      integrityRateList &&
        integrityRateList.forEach((item, index) => {
          item.key = index + 1;
        });
      setRating(healthScore ? healthScore : 0);
      setDataSource(integrityRateList ? integrityRateList : []);
    });
  };

  const RenderScore = ({ value }) => {
    return value >= 0 && value < 60 ? (
      <span style={{ color: "#FF0000" }}>不合格</span>
    ) : value >= 60 && value < 80 ? (
      <span style={{ color: "#FFA500" }}>合格</span>
    ) : value >= 80 && value < 90 ? (
      <span style={{ color: "#FFFF00" }}>良好</span>
    ) : value >= 90 ? (
      <span style={{ color: "#008000" }}>优秀</span>
    ) : null;
  };

  return (
    <div style={{ marginTop: 20 }}>
      <div className="health-wrap" style={{ display: "flex" }}>
        <div className="health-l" style={{ width: 400 }}>
          <div>
            <p>
              设备健康评分
              <b
                style={{
                  fontSize: 40,
                  color: "#27F048",
                  paddingLeft: 20,
                }}
              >
                {rating}
              </b>
            </p>
            <p>
              设备目前处于
              <RenderScore value={rating} />
              状态
            </p>
          </div>
          <Table
            loading={loading}
            columns={columns}
            dataSource={dataSource}
            pagination={false}
          />
        </div>
        <div
          className="health-r"
          style={{ width: "calc(100% - 400px)", marginLeft: 180 }}
        >
          <div
            className="health-r-tr"
            style={{
              display: "flex",
            }}
          >
            <div
              className="health-r-td"
              style={{
                flex: 2,
                borderBottom: "1px solid #DEDEDE",
                borderLeft: "1px solid #DEDEDE",
                borderTop: "1px solid #DEDEDE",
                padding: "15px",
              }}
            >
              0-60
            </div>
            <div
              className="health-r-td"
              style={{
                flex: 2,
                borderBottom: "1px solid #DEDEDE",
                borderLeft: "1px solid #DEDEDE",
                borderTop: "1px solid #DEDEDE",
                padding: "15px",
              }}
            >
              不合格
            </div>
            <div
              className="health-r-td"
              style={{
                flex: 6,
                border: "1px solid #DEDEDE",
                padding: "15px",
              }}
            >
              设备保养存在较多问题，对设备运行造成一定威胁，需限期整改
            </div>
          </div>

          <div
            className="health-r-tr"
            style={{
              display: "flex",
            }}
          >
            <div
              className="health-r-td"
              style={{
                flex: 2,
                borderBottom: "1px solid #DEDEDE",
                borderLeft: "1px solid #DEDEDE",
                padding: "15px",
              }}
            >
              60-79
            </div>
            <div
              className="health-r-td"
              style={{
                flex: 2,
                borderBottom: "1px solid #DEDEDE",
                borderLeft: "1px solid #DEDEDE",
                padding: "15px",
              }}
            >
              合格
            </div>
            <div
              className="health-r-td"
              style={{
                flex: 6,
                border: "1px solid #DEDEDE",
                borderTop: 0,
                padding: "15px",
              }}
            >
              设备保养工作基本满足要求，但存在一些问题，需要及时整改
            </div>
          </div>

          <div
            className="health-r-tr"
            style={{
              display: "flex",
            }}
          >
            <div
              className="health-r-td"
              style={{
                flex: 2,
                borderBottom: "1px solid #DEDEDE",
                borderLeft: "1px solid #DEDEDE",
                padding: "15px",
              }}
            >
              80-89
            </div>
            <div
              className="health-r-td"
              style={{
                flex: 2,
                borderBottom: "1px solid #DEDEDE",
                borderLeft: "1px solid #DEDEDE",
                padding: "15px",
              }}
            >
              良好
            </div>
            <div
              className="health-r-td"
              style={{
                flex: 6,
                border: "1px solid #DEDEDE",
                borderTop: 0,
                padding: "15px",
              }}
            >
              设备保养工作基本到位，设备运行正常，个别方面稍有不足
            </div>
          </div>

          <div
            className="health-r-tr"
            style={{
              display: "flex",
            }}
          >
            <div
              className="health-r-td"
              style={{
                flex: 2,
                borderBottom: "1px solid #DEDEDE",
                borderLeft: "1px solid #DEDEDE",
                padding: "15px",
              }}
            >
              90+
            </div>
            <div
              className="health-r-td"
              style={{
                flex: 2,
                borderBottom: "1px solid #DEDEDE",
                borderLeft: "1px solid #DEDEDE",
                padding: "15px",
              }}
            >
              优秀
            </div>
            <div
              className="health-r-td"
              style={{
                flex: 6,
                border: "1px solid #DEDEDE",
                borderTop: 0,
                padding: "15px",
              }}
            >
              保养工作执行出色，设备状况良好
            </div>
          </div>
        </div>
      </div>
      <div style={{ marginTop: 32, display: "flex" }}>
        {dataSource.map((item) => {
          return (
            <span>
              设备累计发生{item.alarmName}
              {item.times}次，
            </span>
          );
        })}
        <span>综合评分{rating}</span>
        处于
        <RenderScore value={rating} />
        状态
      </div>
    </div>
  );
};
